import { AuthStatus } from '$lib/auth';

const AGREEMENTS_PATHNAME = '/agreements-and-policies';

export const getAgreementsRedirect = (
  authStatus: AuthStatus,
  isLegalAccepted: boolean | undefined,
  currentPathname: string
): string | undefined => {
  if (
    isLegalAccepted !== false ||
    authStatus !== AuthStatus.LoggedIn ||
    currentPathname === AGREEMENTS_PATHNAME
  ) {
    return undefined;
  }

  return `${AGREEMENTS_PATHNAME}?backto=${encodeURIComponent(currentPathname)}`;
};
